module.exports = __webpack_public_path__ + "images/emoji/rabbit2.3e0c693a721a9a3c4fd6.png";